angular.module('jv.requisition.liRecommendations.controller', [])
    .controller('ReqsLiRecommendationsCtrl', ['$scope', 'Reqs',
        function ($scope, Reqs) {
            $scope.loadLiIFrameUrl = function() {
                        $scope.liIframeUrl = $scope.liApiRestUrl.format(window.companyEID || window._jvselfUser.companyEId)+'?widget=RM&jobEId='+$scope.params.id;
                        $scope.flags.loading = false;
            };

            $scope.liApiRestUrl = window.jvUrls.jhire + '/action/liintegration/li-id/{0}';
            //GAMMA-1223 -In case of pagination-the next and prev option - the variable $scope.params.id is not populated and hence its going as undefined.
            //Added code to check the value and then load the URL else if id is undefined setting value in refresh scenario section.
             if ($scope.$parent.tabClicked === 'lirecommendations' && !$.isEmptyObject($scope.params) && typeof $scope.params.id!== 'undefined') {
                 $scope.loadLiIFrameUrl();
             } else if($scope.activeTab('#/lirecommendations')){
                var options = angular.extend({
                paginated: $scope.flags.paginated
                }, $scope.params);
                /*Refresh Scenario*/
                if (!$.isEmptyObject($scope.params)) {
                    Reqs.details(options, function (requisition) {
                        angular.extend($scope.requisitions, requisition);
                        if ($scope.requisitions.forumBaseUrl) {
                            $scope.$root.forumBaseUrl = $scope.requisitions.forumBaseUrl;
                        }
                        $scope.params.id = $scope.requisitions.jobDetails.EId;
                        $scope.loadLiIFrameUrl();
                    });
                }
            }


        }
    ]);